<template>
  <div>
    <div style="display: flex; align-items: center; padding: 30px">
      <span style="font-size: 24px; font-weight: bold">
        OPTION LIST {{ store_name != null ? " IN " + store_name : null }}
      </span>
      <v-divider vertical class="mx-3"></v-divider>
      <v-btn
        dark
        fab
        color="primary"
        @click="toAddOption()"
        v-if="!isEditProductList"
      >
        <v-icon color="black">add</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="info" @click="transferOptionDialog = true"
        >click to transfer option</v-btn
      >
    </div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-flex xs8>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              label="Search name"
              single-line
              hide-details
              style="padding: 0"
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-select
              prepend-icon="search"
              label="Product status"
              v-model="search_by_status"
              item-text="name"
              item-value="value"
              :items="[
                { name: 'All', value: 99 },
                { name: 'Active', value: 1 },
                { name: 'Inactive', value: 0 },
              ]"
            ></v-select>
          </v-flex>
        </v-toolbar>
      </v-flex>
    </v-layout>

    <v-data-table
      :loading="fetching"
      :headers="headers"
      :items="filteredOptionList"
      :hide-actions="hideActionsTable"
      :pagination.sync="pagination"
      item-key="option_id"
      :expand="expand"
      ref="optionTable"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs-center" @click="props.expanded = !props.expanded">
            {{ countIndex(props.item) }}
          </td>
          <td class="text-xs-center" @click="props.expanded = !props.expanded">
            {{ props.item.option_name_th }}
          </td>
          <td class="text-xs-center" @click="props.expanded = !props.expanded">
            {{ props.item.option_name_en }}
          </td>
          <td class="text-xs-center" @click="props.expanded = !props.expanded">
            {{ props.item.option_type == "1" ? "Single" : "Multiple" }}
          </td>
          <td class="text-xs-center" @click="props.expanded = !props.expanded">
            {{ props.item.option_amount }}
          </td>
          <td
            class="text-xs-center"
            @click="props.expanded = !props.expanded"
            v-if="props.item.option_require == true"
          >
            <v-icon color="green">check</v-icon>
          </td>
          <td
            class="text-xs-center"
            @click="props.expanded = !props.expanded"
            v-else
          >
            <v-icon color="red">close</v-icon>
          </td>

          <td class="text-xs-center" @click="props.expanded = !props.expanded">
            {{ props.item.option_choice.length }}
          </td>
          <td class="text-xs-center">
            <v-switch
              :disabled="isEditProductList"
              v-model="props.item.option_status"
              color="primary"
              class="mt-2"
              style="max-width: 50px"
              :false-value="0"
              :true-value="1"
              @change="changeStatus(props.item)"
            ></v-switch>
          </td>
          <td class="px-0">
            <v-btn
              small
              icon
              @click="toEditOption(props.item, props.index)"
              v-if="sort_data == false"
            >
              <v-icon small>{{
                isEditProductList ? "remove_red_eye" : "edit"
              }}</v-icon>
            </v-btn>

            <v-btn
              small
              icon
              @click="delOptionItem(props.item)"
              :disabled="isEditProductList"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>

      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text class="text-xs-left">
            <ul style="font-weight: bold">
              Choice List
            </ul>
            <li v-for="(n, i) in props.item.option_choice" :key="i">
              {{ n.choice_name_th }}
              <span style="color: grey" class="pr-5">
                {{
                  n.choice_name_en != null ? `(${n.choice_name_en})` : ""
                }}</span
              >
              <span style="color: green">{{ `฿ ${n.choice_price}` }}</span>
            </li>
          </v-card-text>
        </v-card>
      </template>

      <template slot="no-data">
        <div class="text-xs-center px-3" v-if="fetching == true">
          Loading ...
        </div>
        <label v-if="fetching == false">NO DATA AVAILABLE</label>
        <br />
        <v-btn
          color="info"
          @click="initialize()"
          v-if="fetching == false && selected_type == 0"
          ><v-icon>refresh</v-icon></v-btn
        >
      </template>
    </v-data-table>
    <add-edit-option-dialog
      @close="formOptionDialog = false"
      @save="submitFormOption()"
      @reset="setForm()"
      :dialog="formOptionDialog"
      :selectedIndex="selectedIndex"
      :form="form"
    ></add-edit-option-dialog>
    <transfer-option-dialog
      :dialog="transferOptionDialog"
      @save="transferOption($event)"
      @close="transferOptionDialog = false"
    ></transfer-option-dialog>
  </div>
</template>

<script>
import AddEditOptionDialog from "@/components/back-office/InStore/ProductManagement/Option/AddEditOptionDialog.vue";
import TransferOptionDialog from "@/components/back-office/InStore/ProductManagement/Option/TransferOptionDialog.vue";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    transferOptionDialog: false,
    formOptionDialog: false,
    expand: false,
    confirm_dialog_dup: false,
    confirm_dialog_del: false,
    dupplitcating_product: false,
    search_by_status: 99,
    selected_type: 0,
    enabled: true,
    data_for_sort: {},
    sort_data: false,
    sort_msg: 0,
    cancel_sort: false,
    sorting_data: false,
    search: "",
    fetching_data: false,
    original_data: null,
    form: {},
    fetching: false,
    productDialog: false,
    dialog: false,
    selectedIndex: -1,
    hideActionsTable: false,
    pagination: {
      page: 1,
      rowsPerPage: 10,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "name",
      },
      {
        text: "NAME TH",
        align: "center",
        value: "product_code",
        sortable: false,
      },
      {
        text: "NAME EN",
        align: "center",
        value: "img",
        sortable: false,
      },
      {
        text: "TYPE",
        align: "center",
        value: "product_name",
        sortable: false,
      },
      {
        text: "SELECT AMOUNT",
        align: "center",
        value: "product_sale_price",
        sortable: false,
      },
      {
        text: "REQUIRED",
        align: "center",
        value: "product_base_price",
        sortable: false,
      },
      {
        text: "CHOICE AMOUNT ",
        align: "center",
        value: "product_status",
        sortable: false,
      },
      {
        text: "STATUS",
        align: "center",
        value: "action",
        sortable: false,
      },
      {
        text: "",
        align: "center",
        value: "action",
        sortable: false,
      },
    ],
  }),
  components: {
    "add-edit-option-dialog": AddEditOptionDialog,
    "transfer-option-dialog": TransferOptionDialog,
  },
  computed: {
    ...mapState({
      store_name: (state) => state.storeBack.store_name,
      product_type_list: (state) =>
        state.fetchProductTypeBack.product_type_list,
      currentStoreId: (state) => state.storeBack.store_detail_id,
      storeOptionList: (state) => state.product.storeOptionList,
      storeOptionV1List: (state) => state.product.storeOptionV1List,
    }),
    ...mapGetters({
      product_list: "fetchProductListBack/productListTable",
      isEditProductList: "isEditProductList",
    }),
    filteredOptionList() {
      console.log(this.storeOptionList);
      if (this.search_by_status == 99) {
        if (this.search == "") {
          return this.storeOptionList;
        } else {
          return this.storeOptionList.filter((value) => {
            return (
              value.option_name_th.toString().includes(this.search) ||
              value.option_name_en.toString().includes(this.search)
            );
          });
        }
      } else {
        return this.storeOptionList.filter((value) => {
          return (
            (value.option_status == this.search_by_status &&
              value.option_name_th.toString().includes(this.search)) ||
            value.option_name_en.toString().includes(this.search)
          );
        });
      }
    },
  },

  created() {
    this.setForm();
    this.initialize();
  },
  mounted() {},
  methods: {
    ...mapActions({
      CREATE_OPTION: "product/CREATE_OPTION_ITEM",
      EDIT_OPTION: "product/EDIT_OPTION_ITEM",
      FETCH_V1_OPTION_LIST: "product/FETCH_V1_OPTION_LIST",
      FETCH_OPTION_LIST: "product/FETCH_OPTION_LIST",
      DELETE_OPTION_ITEM: "product/DELETE_OPTION_ITEM",
      TRANSFER_V1_OPTION: "product/TRANSFER_V1_OPTION",
    }),
    async transferOption(optionList) {
      this.transferOptionDialog = false;
      this.fetching = true;
      let payload = {
        option_id: optionList,
      };
      await this.TRANSFER_V1_OPTION(payload);
      this.fetching = false;
    },

    async changeStatus(item) {
      const check_success = await this.EDIT_OPTION(item);
      if (check_success == false) {
        item.option_status = !item.option_status;
      }
    },
    countIndex(item) {
      return this.filteredOptionList.indexOf(item) + 1;
    },
    toAddOption() {
      this.setForm();
      this.selectedIndex = -1;
      this.formOptionDialog = true;
    },
    async toEditOption(item, index) {
      this.form = JSON.parse(JSON.stringify(item));
      this.formOptionDialog = true;
      this.selectedIndex = index;
    },
    submitFormOption() {
      if (this.selectedIndex == -1) {
        this.CREATE_OPTION(this.form);
      } else {
        this.EDIT_OPTION(this.form);
      }
    },
    setForm() {
      this.form = {
        option_store_id: this.currentStoreId,
        option_id: null,
        option_name_th: "",
        option_name_en: "",
        option_name_cn: "",
        option_type: 1,
        option_require: false,
        option_amount: 1,
        option_status: false,
        option_choice: [
          {
            choice_id: null,
            choice_name_th: "",
            choice_name_en: "",
            choice_name_cn: "",
            choice_price: 0,
          },
        ],
      };
    },
    async delOptionItem(item) {
      let n = await this.$confirm("Do you want to delete this option ?");
      if (n == true) {
        this.DELETE_OPTION_ITEM(item.option_id);
      }
    },
    async fetchNewData() {
      this.$store.commit("product/SET_OPTION_LIST", []);
      await this.FETCH_V1_OPTION_LIST(this.currentStoreId);
      await this.FETCH_OPTION_LIST(this.currentStoreId);
      return;
    },
    async initialize() {
      this.fetching = true;
      if (this.currentStoreId == null) {
        let store_detail = await this.$store.dispatch(
          "fetchStoreBack/getStoreDetail",
          this.$route.params.store_id
        );
        this.$store.commit(
          "storeBack/setStoreDetailId",
          store_detail.store.store_id
        );
      }
      await this.fetchNewData();
      if (this.storeOptionList.length > 0) {
        const item = this.storeOptionList[0];
        this.$set(this.$refs.optionTable.expanded, item.option_id, true);
      }
      this.fetching = false;
    },
  },
};
</script>
<style scoped>
.ribbon-rec {
  background-color: rgba(255, 255, 255, 0.817);
  color: black;
  padding: 1px 5px;
  margin-top: 3px;
  position: absolute;
  border-radius: 0px 2px 2px 0px;
}
.ribbon-best {
  background-color: #ffd500c2;
  color: black;
  padding: 1px 5px;
  margin-top: 3px;
  position: absolute;
  width: 70px;
  border-radius: 0px 2px 2px 0px;
}
</style>


